import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export const getActivitiesDocuments = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getActivityAttachments${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const insertActivitiesDocuments = (myFile, query, token) => {
  let qs = buildQuery(query);
  return axios.post(`${baseUrl}/insertActivityAttachment${qs}`, myFile, {
    headers: {
      authorization: token,
    },
  });
};
export const getDownloadActivitiesDocumentsFile = (id, token) => {
  // let qs = buildQuery(query);
  let url = `${baseUrl}/getDownloadActivityAttachment/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
export const deleteActivitiesDocuments = (id, token) => {
  let url = `${baseUrl}/deleteActivityAttachment/${id}`;
  return axios.delete(url, {
    headers: {
      authorization: token,
    },
  });
};
